.mvAppWrapper {
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    position: relative;
}

.hide {
    display: none;
}

.optionsError {
    color: red;
    padding: 1rem;
}
